import React from 'react';

import { getArticleGroupContent } from 'SharedHelpers/getArticleGroupContent';

import { getNativeAd } from 'SharedPartials/getNativeAd';
import { getArticleGroup } from 'SharedPartials/getArticleGroup';

/**
* Return Most popular article group.
* @param {String} datePosition Position for date meta/bottom.
* @param {String} nativeAd Required native ad key i.e 'native_article'.
* @param {String} nativeAdRefresh Default 'no'
* @param {String} title Group title.
*/
export const getMostPopularArticleGroup = ({
  articleCardProps = {
    datePosition: 'meta',
    excerpt: null,
    isHeading: false,
  },
  articlesPerRow = 4,
  associatedContent,
  extraClassNames,
  nativeAd,
  nativeAdRefresh = 'no',
  title = 'Most Popular',
}) => {
  const groupContentOptions = {
    related: associatedContent,
    key: 'mostPopular',
  };

  if (nativeAd) {
    groupContentOptions.injectedItem = {
      component: [
        <React.Fragment key="native_ad">
          {getNativeAd({
            id: 'ad_native',
            targeting: {
              position: nativeAd,
              placement: nativeAd,
              refresh: nativeAdRefresh,
            },
          })}
        </React.Fragment>,
      ],
    };
  }

  return getArticleGroup({
    articleCardProps,
    articlesPerRow,
    extraClassNames,
    content: getArticleGroupContent(groupContentOptions),
    title,
  });
};
